module.exports = __webpack_public_path__ + "assets/616ec901dedd4007fa37dd189ab70ddc.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/buttons/coins/bet+5.mp3
 ** module id = 228
 ** module chunks = 0
 **/